import Button, { ButtonProps } from 'lib/components/Button/Button'
import React, { forwardRef, RefObject } from 'react'
import { useTranslation } from 'react-i18next'

const ActionDialogDeleteButton = forwardRef((props: ButtonProps, ref: RefObject<HTMLButtonElement>) => {
  const [t] = useTranslation()

  return (
    <Button {...props} ref={ref} type="button" variant="warning" size="small">
      {t('home.admin.actionDialog.delete')}
    </Button>
  )
})

ActionDialogDeleteButton.displayName = 'ActionDialogDeleteButton'
export default ActionDialogDeleteButton
